<div class="flex justify-between items-center py-4">
  <h2 class="text-lg font-semibold text-indigo-900">
    @if (isViewMode) {
      <span class="ms-2 text-sm font-normal text-gray-500"> ({{ 'ONBOARDING.VIEW_MODE' | translate }}) </span>
    }
  </h2>
  <app-back-button></app-back-button>
</div>
<fieldset [disabled]="isViewMode" class="contents">
  <div class="bg-white rounded-xl p-2 sm:p-6 space-y-8" style="font-weight: 500 !important">
    @if (questions.length > 0) {
      <section>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          @for (q of questions; track q.questionId) {
            @if (isQuestionVisible(q)) {
            <div class="question-card">
              <p class="question">
                {{ q.question }}
                <span class="text-red-500">*</span>
              </p>

              <!-- RADIO -->
              @if (q.inputType === 'radio') {
                <div class="radio-group mt-2">
                  @for (a of q.answers; track a.answer) {
                    <label class="radio">
                      <input
                        type="radio"
                        [name]="'q_' + q.questionId"
                        [(ngModel)]="q.value"
                        [value]="a.answer"
                        (ngModelChange)="onAnswerChange(q)"
                      />
                      {{ a.answer }}
                    </label>
                  }
                </div>
              }

              <!-- CHECKBOX -->
              @if (q.inputType === 'checkbox') {
                <div class="checkbox flex flex-wrap gap-6 mt-2">
                  @for (a of q.answers; track a.answer) {
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        (change)="toggleCheckbox(q, a.answer)"
                        [checked]="q.value?.includes(a.answer)"
                      />
                      {{ a.answer }}
                    </label>
                  }
                </div>
              }

              <!-- SELECT / DROPDOWN -->
              @if (q.inputType === 'select') {
                <select
                  class="form-input mt-2"
                  [(ngModel)]="q.value"
                  (ngModelChange)="onAnswerChange(q)"
                  [class.border-red-500]="isInvalid(q)"
                >
                  <option [ngValue]="null">{{ 'COMMON.SELECT' | translate }}</option>
                  @for (a of q.answers; track a.answer) {
                    <option [value]="a.answer">
                      {{ a.answer }}
                    </option>
                  }
                </select>
              }

              <!-- DATE INPUT (calendar only, typing blocked) -->
              @if (isDateQuestion(q)) {
                <input
                  class="form-input mt-2"
                  type="date"
                  [(ngModel)]="q.value"
                  (keydown)="blockManualDateEntry($event)"
                  [class.border-red-500]="isInvalid(q)"
                />
              }

              <!-- TEXT INPUT -->
              @if (q.inputType === 'text' && isAmountQuestion(q)) {
                <input
                  class="form-input mt-2"
                  type="text"
                  inputmode="numeric"
                  [value]="formatAmount(q.value)"
                  [placeholder]="q.question"
                  (keydown)="blockDisallowedKey($event, q)"
                  (input)="onAmountInput($event, q)"
                  [class.border-red-500]="isInvalid(q)"
                />
              }

              @if (q.inputType === 'text' && !isDateQuestion(q) && !isAmountQuestion(q)) {
                <input
                  class="form-input mt-2"
                  type="text"
                  [(ngModel)]="q.value"
                  [placeholder]="q.question"
                  [attr.maxlength]="getMaxLength(q)"
                  (keydown)="blockDisallowedKey($event, q)"
                  (input)="stripDisallowedCharacters($event, q)"
                  [class.border-red-500]="isInvalid(q)"
                />
                @if (showsCharacterCount(q) && !isInvalid(q)) {
                  <div
                    class="text-xs mt-1 text-end"
                    [class.text-gray-400]="answerLength(q) < ANSWER_MAX_LENGTH"
                    [class.text-red-500]="answerLength(q) >= ANSWER_MAX_LENGTH"
                  >
                    @if (answerLength(q) >= ANSWER_MAX_LENGTH) {
                      {{ 'ONB_KYC.MAX_CHARACTERS_REACHED' | translate: { max: ANSWER_MAX_LENGTH } }}
                    }
                    {{ answerLength(q) }}/{{ ANSWER_MAX_LENGTH }}
                  </div>
                }
              }

              @if (isInvalid(q)) {
                <div class="text-red-500 text-xs mt-1">
                  {{ getErrorMessage(q) }}
                </div>
              }

              @if (hasSpecifyField(q)) {
                <div class="mt-4">
                  <label class="form-label">
                    {{ 'ONB_KYC.PLEASE_SPECIFY_LABEL' | translate }}
                    @if (isSpecifyTriggered(q)) {
                      <span class="text-red-500">*</span>
                    }
                  </label>
                  <input
                    class="form-input"
                    [(ngModel)]="q.specify"
                    [disabled]="!isSpecifyTriggered(q) || isViewMode"
                    [class.opacity-50]="!isSpecifyTriggered(q)"
                    [class.cursor-not-allowed]="!isSpecifyTriggered(q)"
                    [class.border-red-500]="isSpecifyInvalid(q)"
                    [placeholder]="'ONB_KYC.PLEASE_SPECIFY' | translate"
                  />
                  @if (isSpecifyInvalid(q)) {
                    <div class="text-red-500 text-xs mt-1">{{ 'ONB_KYC.PLEASE_SPECIFY' | translate }}</div>
                  }
                </div>
              }
            </div>
            }
          }
        </div>
      </section>
    }
  </div>
</fieldset>

<!-- Edit mode: Save & Continue -->
@if (!isViewMode) {
  <div class="flex gap-4 mt-6">
    <button class="btn-primary" (click)="save()">{{ 'ONBOARDING.SAVE_AND_CONTINUE' | translate }}</button>
  </div>
}

<!-- View mode: sirf Continue (bina save kiye) -->
@if (isViewMode) {
  <div class="flex gap-4 mt-6">
    <button class="btn-primary" (click)="goToUbos()">{{ 'COMMON.CONTINUE' | translate }}</button>
  </div>
}
